import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { OrderEntry, PrePrintedLabel } from '../../../../../core/model';
import { CartState, PrePrintedLabelsState, StateWithCart } from '../cart-state';
import { getCartState } from './feature.selector';

export const getPrePrintedLabelState: MemoizedSelector<StateWithCart, PrePrintedLabelsState> = createSelector(
  getCartState,
  (state: CartState) => state && state.prePrintedLabels
);

// Options
export const getPrePrintedLabelOptionsState = (
  entry: OrderEntry
): MemoizedSelector<StateWithCart, StateUtils.LoaderState<PrePrintedLabel[]>> =>
  createSelector(getPrePrintedLabelState, (state: PrePrintedLabelsState) => state && state[entry.entryNumber]?.options);

export const getPrePrintedLabelOptions = (entry: OrderEntry): MemoizedSelector<StateWithCart, PrePrintedLabel[]> =>
  createSelector(getPrePrintedLabelOptionsState(entry), (state) => (state && StateUtils.loaderValueSelector(state)) || undefined);

export const getPrePrintedLabelOptionsLoading = (entry: OrderEntry): MemoizedSelector<StateWithCart, boolean> =>
  createSelector(getPrePrintedLabelOptionsState(entry), (state) => (state && StateUtils.loaderLoadingSelector(state)) || false);

// Inner package quantity required
export const getPrePrintedLabelInnerPackageQuantityRequiredState = (
  entry: OrderEntry
): MemoizedSelector<StateWithCart, StateUtils.LoaderState<boolean>> =>
  createSelector(
    getPrePrintedLabelState,
    (state: PrePrintedLabelsState) => state && state[entry.entryNumber]?.innerPackageQuantityRequired
  );

export const getPrePrintedLabelInnerPackageQuantityRequired = (entry: OrderEntry): MemoizedSelector<StateWithCart, boolean> =>
  createSelector(
    getPrePrintedLabelInnerPackageQuantityRequiredState(entry),
    (state) => (state && StateUtils.loaderValueSelector(state)) || false
  );

export const getPrePrintedLabelInnerPackageQuantityRequiredLoading = (
  entry: OrderEntry
): MemoizedSelector<StateWithCart, boolean> =>
  createSelector(
    getPrePrintedLabelInnerPackageQuantityRequiredState(entry),
    (state) => (state && StateUtils.loaderLoadingSelector(state)) || false
  );
